let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8VBC2")).then(() => parcelRequire('ctW5D'));